import React from "react";

import { lerpColor } from "@Utils";
import { Bar, BarConfig } from "@ant-design/charts";

interface IProps {
    values: number[];
    labels: string[];
    timeFormat: boolean;
    maxBarWidth?: number;
    height?: number;
}

const HorizontalBar: React.FC<IProps> = ({ values, labels, maxBarWidth, height }: IProps) => {
    const data = [
        ...values.map((item, index) => {
            return {
                label: labels[index],
                type: labels[index],
                value: item,
            };
        }),
    ];

    const config: BarConfig = {
        color: [
            ...values.map((item, index) => {
                const alpha = parseFloat(`0.${1 + index}`);
                return (
                    "l(270)" +
                    " 0:" +
                    lerpColor("#457db0", "#5da3e3", "#a1c8eb", alpha) +
                    " 1:" +
                    lerpColor("#5887b3", "#7eacd7", "#a8c3db", alpha)
                );
            }),
        ],
        data,
        maxBarWidth,
        height,
        isGroup: true,
        xField: "value",
        yField: "label",
        seriesField: "type",
        marginRatio: 0,
        legend: false,
        animation: false,
        label: {
            position: "middle",
            formatter: function formatter({ value }) {
                if (!value) {
                    return "0m";
                }
                const hours: number = Math.floor(value / 3600);
                const mins: number = Math.floor((value % 3600) / 60);
                const secs: number = Math.floor(value % 60);
                if (hours == 0 && mins == 0) return "< 1m";
                return String((hours > 0 ? hours + "h" + " " : "") + mins + "m " + secs + "s");
            },
            style: {
                fill: "#fff",
                fontSize: 20,
            },
        },
        tooltip: {
            formatter: ({ value, type }) => {
                if (!value) {
                    return { name: type, value: "0m" };
                }
                const hours: number = Math.floor(value / 3600);
                const mins: number = Math.floor((value % 3600) / 60);
                const secs: number = Math.floor(value % 60);
                if (hours == 0 && mins == 0) {
                    return { name: type, value: "< 1m" };
                }
                return { name: type, value: String((hours > 0 ? hours + "h" + " " : "") + mins + "m " + secs + "s") };
            },
        },
    };
    return <Bar {...config} />;
};

export default HorizontalBar;
